import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
// import { apiurl } from '../../../../path';
import { Link } from "react-router-dom";
// import "./rejectpanel.css";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GooglePagination from "../../../styles/GooglePagination";
import { formatDateTime, formatDate } from "../../../../../utils/DateFormat";
import { filterStyle,filterWrapperStyle } from "../../../styles/filterStyles";

const ViewDemandGeneration = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const {
    GetBudgetHeadInfo,
    TechnicalOutwards,
    Usermenu,
    TrackBills,
    GetDemandGenerationbyID,
  } = context;

  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [proposallist, setProposalList] = useState([]);

  const [UserRole, setUserRole] = useState("");
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  // const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState("");
  const [statusofData, setstatusofData] = useState("Sent to Bank");
  const [statusofData1, setstatusofData1] = useState("");
  const [RoleID, setroleID] = useState(null);
  const [typeofData, settypeofData] = useState("District");
  const [openDistrict, setOpenDistrict] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const budgetEstimation = proposallist;

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  console.log("All Bill data: ", technicalInwards);

  const [exportingPDF, setExportingPDF] = useState(false);
  const [loading, setloading] = useState(false);
  const displayedGRS = exportingPDF ? filteredBills : currentBills;
  const [showspecific, setShowSpecific] = useState(0);
  const [approval, setapproval] = useState([]);
  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };
  const commonWidth = `${100 / 7}%`; // whatever the current width of Department Auditor looks like

  const headerStyle1 = {
    width: commonWidth,
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const cellStyle = {
    width: commonWidth, // 100% / 7 columns
    padding: "8px",
    textAlign: "center",
    //   whiteSpace: 'nowrap'
  };

  const getTechnicalInwardsList = async () => {
    let data = await GetBudgetHeadInfo("All", "GetDemandGenerationList");
    let data1 = await TrackBills();
    const { status, message, Tabletype } = data1;

    if (status) {
      setTechnicalInwards(message);
      setProposalList(message);
      // setFilteredBills(message);
      setUserRole(Tabletype);
    } else {
      alert(message);
    }
  };
  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID);
      console.log("sffdsf", data?.Data);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };
  useEffect(() => {
    getTechnicalInwardsList();
    getmenu();
  }, []);

 const allDistricts = [
  ...new Set(
    AllDistrict
      ?.map((d) =>
        d?.District_Marathi?.split("-")[0]?.trim()
      )
      .filter(Boolean)
  ),
];
  const isAllSelected = SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
  const handleDistrictToggle = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };

  useEffect(() => {
    let filtered = [...technicalInwards];
    if (typeofData === "District" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.BudgetID?.startsWith("3054") ||
          item.HeadCode?.startsWith("3054"),
      );
    } else if (typeofData === "State" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.BudgetID?.startsWith("2515") ||
          item.HeadCode?.startsWith("2515"),
      );
    }
    if (typeofData === "" && RoleID === 29) {
      filtered = filtered;
    }
    // 🔹 Filter by District (MULTI-SELECT)
   if (SelectedDistrict?.length > 0) {
  filtered = filtered.filter((item) => {
    const itemDistrict = item?.District || "";

    return SelectedDistrict.some(
      (district) =>
        itemDistrict === district ||
        itemDistrict.startsWith(`${district}-`)
    );
  });
}

    // 🔹 Filter by Approval / Status
    if (statusofData1 === "false") {
      filtered = filtered.filter((item) => item.BillStatus === "Pending");
    }

    if (statusofData1 === "Approved") {
      filtered = filtered.filter((item) => item.BillStatus === "Completed");
    }

    if (statusofData1 === "Rejected") {
      filtered = filtered.filter(
        (item) => item.BillStatus === "Rejected"
      );
    }
    // if (statusofData1 === "") {
    //   filtered = technicalInwards
    // }
    // 🔹 Search Filter
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((bill) =>
        Object.values(bill).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }

    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    statusofData1,
    searchTerm,
    technicalInwards,
    SelectedDistrict,
    typeofData,
  ]);

  //-->old code
  // useEffect(() => {
  //   let filtered = [...technicalInwards];
  //   console.log("All data ---> ", technicalInwards);
  //   if (typeofData === "District" && RoleID === 29) {
  //     filtered = filtered.filter(
  //       (item) =>
  //         item.BudgetID ===
  //         "3054-2419(Roads and bridge repair maintenance program)",
  //     );
  //     console.log("filtered Date 3054", filtered);
  //   } else if (typeofData === "State" && RoleID === 29) {
  //     filtered = filtered.filter(
  //       (item) => item.BudgetID === "2515-1238(MLA Representative)",
  //     );
  //   }
  //   // 🔹 Filter by District (MULTI-SELECT)
  //   if (SelectedDistrict?.length > 0) {
  //     filtered = filtered.filter((item) =>
  //       SelectedDistrict.includes(item.District),
  //     );
  //   }

  //   // 🔹 Filter by Approval / Status
  //    if (statusofData1 === "false") {
  //     filtered = filtered.filter(
  //       (item) => item.BillStatus?.toLowerCase() === "pending"
  //     );
  //   }

  //   if (statusofData1 === "Approved") {
  //     filtered = filtered.filter(
  //       (item) => item.BillStatus?.toLowerCase() === "completed"
  //     );
  //   }

  //   console.log("Filter data ---> ", filtered);

  //   // 🔹 Search Filter
  //   if (searchTerm.trim()) {
  //     const lower = searchTerm.toLowerCase();
  //     filtered = filtered.filter((bill) =>
  //       Object.values(bill).some((val) =>
  //         String(val ?? "")
  //           .toLowerCase()
  //           .includes(lower),
  //       ),
  //     );
  //   }

  //   setFilteredBills(filtered);
  //   setCurrentPage(1);
  // }, [
  //   statusofData1,
  //   searchTerm,
  //   technicalInwards,
  //   SelectedDistrict,
  //   typeofData,
  // ]);

  const selectedBillDetails = (BillID) => {
    const result = budgetEstimation
      .filter((item) => item.DemandGenerationID == BillID)
      .map((item) => ({
        "Demand ID": item.DemandGenerationID,
        "Bill Number": item.RABillNumber,
        "Proposal ID": item.ProjectID,
        "Head ID": item.BudgetID,
        District: item.District,
        "Contractor Name": item.ContractorName,
        "Work Order UID": item.WorkOrderUID,
        "Upload Demand Copy": item.UploadBillCopy,
        Remark: item.Remark,
        "Bill Amount": item.BillAmount,
        "Net Payable Amount": item.NetPayableAmount,
        "Deduction Amount": item.DeductionAmount,
        Date: new Date(item.Date).toLocaleString(),
      }));

    console.log("------------------", result);
    setSelectedProposal(result[0]);
  };

  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      // console.log("Data i get:: ", res);
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);

  const totalBillamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.BillAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const totalpayableamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.NetPayableAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const totaldeductionamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.DeductionAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const exportTableByClassToExcel = async (
    bills,
    filename = "Bills_Outward.xlsx",
  ) => {
    if (!bills || bills.length === 0) {
      alert("No data available");
      return;
    }

    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const getStatus = (val) =>
        val === "true" ? "✓" : val === "false" ? "✕" : "-";

      const excelData = bills.map((proposal, index) => ({
        "Sr.No.": index + 1,

        "Demand ID": proposal.DemandGenerationID || "-",

        "Bill Receive Date": proposal.Date
          ? 
            formatDateTime(proposal.Date)
          : "-",

        Designation: proposal.CurrentDesignation || "-",

        "Bill Status":
          proposal.BillStatus === "Completed"
            ? "Release by BDS"
            : proposal.BillStatus || "-",
      }));

      /* 🔢 TOTAL ROW */
      const totalRow = {
        "Sr.No.": `Total Records : ${bills.length}`,
        "Demand ID": "",
        "Bill Receive Date": "",
        "Designation": "",
        "Bill Status": ""
      };

      excelData.push(totalRow);

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      /* Column width */
      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({
        wch: 22,
      }));

      /* Freeze header */
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      /* Filter */
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };

  const downloadTableOnlyAsPDF = async (
    tableClass,
    filename,
    title,
    chunkSize = 500, // 🔥 300–500 recommended
  ) => {
    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
      setExportingPDF(false);
      return;
    }

    setloading(true);
    setExportingPDF(true);

    // Allow loader to render first
    await new Promise((resolve) => setTimeout(resolve, 600));

    try {
      const originalRows = originalTable.querySelectorAll("tbody tr");
      const totalRows = originalRows.length;

      if (!totalRows) {
        setloading(false);
        setExportingPDF(false);
        return;
      }

      for (let start = 0; start < totalRows; start += chunkSize) {
        const end = Math.min(start + chunkSize, totalRows);

        // 🔥 Clone table cleanly
        const tableClone = originalTable.cloneNode(true);
        const rows = tableClone.querySelectorAll("tbody tr");

        // Remove rows outside current chunk
        rows.forEach((row, index) => {
          if (index < start || index >= end) {
            row.remove();
          }
        });

        // Hide cloned table from view
        tableClone.style.position = "absolute";
        tableClone.style.left = "-9999px";
        tableClone.style.top = "0";
        document.body.appendChild(tableClone);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
          align: "center",
        });

        const canvas = await html2canvas(tableClone, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#2C78DB",
        });

        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight,
          );

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight,
          );

          const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

          if (pageNumber > 0) pdf.addPage();

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm,
          );

          renderedHeight += sliceHeight;
          pageNumber++;
        }

        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

        document.body.removeChild(tableClone);

        // Small delay prevents UI freezing
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };
  const GetDemandProgressHistory = async (DemandGenerationID) => {
    try {
      let data = await GetDemandGenerationbyID(DemandGenerationID);

      const { status, message } = data;

      if (status) {
        setapproval(data);
        //--> old code
        // setapproval(message);
        setShowSpecific(1);
      } else {
        alert(message);
      }
    } catch (error) {
      console.log("GetDemandProgressHistory Error :: ", error);
    }
  };
  return (
    <>

      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "89vh",
          overflowX: "hidden",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        {showspecific == 0 && (
          <div
            style={{
              filter: loading ? "blur(4px)" : "none",
              pointerEvents: loading ? "none" : "auto",
              transition: "0.2s ease",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12 ">
                <div
                  className="col-12 px-4 mb-4 mt-3"
                  style={{
                    filter: loading ? "blur(4px)" : "none",
                    pointerEvents: loading ? "none" : "auto",
                    transition: "0.2s ease",
                  }}
                >
                  {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                    <h5 className="fw-bold d-flex align-items-center m-0">
                      <img
                        src="/GR-Approval64.png"
                        alt="Technical Approval"
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: "6px",
                        }}
                      />
                      {[24, 25, 29, 40, 41].includes(RoleID)
                        ? t("Track Bill")
                        : t("Track Bill")}
                    </h5>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-success"
                        onClick={() =>
                          exportTableByClassToExcel(
                            filteredBills,
                            "Bills_Outward.xlsx",
                          )
                        }
                      >
                        {t("Download Excel")}
                      </button>

                      <button
                        className="btn btn-danger"
                        onClick={() =>
                          downloadTableOnlyAsPDF(
                            "BillsOutwardTable",
                            "Bills_Outward.pdf",
                            "Bills Outward Report",
                          )
                        }
                      >
                        {t("Download PDF")}
                      </button>
                    </div>
                  </div>

                  {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "nowrap",
                    }}
                  >
                    {UserRole === "State" && RoleID === 29 && (
                      <select
                        value={typeofData}
                        onChange={(e) => settypeofData(e.target.value)}
                        style={filterStyle}
                      >
                        <option value="">Choose Data</option>
                        <option value="District">
                          {t(
                            "3054-2419(Roads and bridge repair maintenance program)",
                          )}
                        </option>
                        <option value="State">
                          {t("2515-1238(MLA Representative)")}
                        </option>
                      </select>
                    )}

                    {/* Status */}
                    <select
                      value={statusofData1}
                      onChange={(e) => setstatusofData1(e.target.value)}
                      style={filterStyle}
                    >
                      <option value="">{t("All")}</option>
                      <option value="Approved">{t("Release by BDS")}</option>
                      <option value="false">{t("Pending")}</option>
                      <option value="Rejected">{t("Rejected")}</option>
                    </select>

                    {/* District */}
                    {UserRole === "State" && (
                      <div style={filterWrapperStyle}>
                        {/* Dropdown trigger */}
                        <div
                          onClick={() => setOpenDistrict(!openDistrict)}
                          style={filterStyle}
                        >
                          {SelectedDistrict.length > 0
                            ? SelectedDistrict.join(", ")
                            : "Select District"}
                        </div>

                        {/* Dropdown list */}
                        {openDistrict && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              width: "100%",
                              background: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              marginTop: "4px",
                              zIndex: 1000,
                            }}
                          >
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 8px",
                                borderBottom: "1px solid #eee",
                                cursor: "pointer",
                                fontSize: "13px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={toggleAllDistricts}
                                style={{ marginRight: "6px" }}
                              />
                              {t("All Districts")}
                            </label>

                            <div
                              style={{
                                maxHeight: "150px",
                                overflowY: "auto",
                              }}
                            >
                              {allDistricts.map((district, index) => (
                                <label
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "6px 8px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={SelectedDistrict.includes(district)}
                                    onChange={() => handleDistrictToggle(district)}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ marginRight: "6px" }}
                                  />
                                  {district}
                                </label>
                              ))}
                            </div>

                            {/* Footer */}
                            <div
                              style={{
                                padding: "6px",
                                textAlign: "right",
                                borderTop: "1px solid #eee",
                              }}
                            >
                              <button
                                onClick={() => setOpenDistrict(false)}
                                style={{
                                  padding: "4px 10px",
                                  fontSize: "12px",
                                  border: "none",
                                  borderRadius: "6px",
                                  background: "#0d6efd",
                                  color: "#fff",
                                  cursor: "pointer",
                                }}
                              >
                                OK
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Search */}
                    <div style={filterWrapperStyle}>
                      <img
                        src="/Search32.png"
                        alt="Search"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          width: "16px",
                          opacity: 0.6,
                          zIndex: 1,
                        }}
                      />

                      <input
                        type="text"
                        placeholder={t("Search Here")}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          ...filterStyle,
                          padding: "8px 12px 8px 32px",
                          backgroundColor: "#f1f6fc",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 pb-5">
                  <div
                    className="m-auto mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "40px 40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                      width: "100%",
                      maxWidth: "100%",
                      overflowX: "hidden",
                    }}
                  >
                    <div
                      className="col-12 tableDesign"
                      style={{ background: "#2C78DB", overflowY: "auto", overflowX: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative", }}
                    >
                      <table
                        className="m-0 p-0 BillsOutwardTable"
                        style={{ width: "100%", borderCollapse: "collapse", fontSize: "18px" }}
                      >
                        <thead style={{ position: "sticky",  background: "#2C78DB",
                      top: 0,
                      zIndex: 10,}} >
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th
                              style={{ minWidth: "70px", padding: "8px", fontSize: "18px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Sr.No.")}
                            </th>
                            <th
                              style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Demand ID")}
                            </th>
                            <th style={{ width: "10%", fontSize: "18px" }}>
                              {t("Bill Amount")}
                            </th>
                            <th
                              style={{ minWidth: "190px", padding: "8px", fontSize: "18px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Bill Receive Date")}
                            </th>
                            <th
                              style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Designation")}
                            </th>
                            <th
                              style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Bill Status")}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <>
                            {displayedGRS?.length === 0 ? (
                              <tr>
                                <td
                                  colSpan="30"
                                  style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                  }}
                                >
                                  {t("No data available")}
                                </td>
                              </tr>
                            ) : (
                              displayedGRS?.map((proposal, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    style={{ backgroundColor: bgColor, fontSize: "18px" }}
                                    key={index}
                                  >
                                    <td style={{ padding: "8px 8px" }}>
                                      {indexOfFirstBill + index + 1}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px 8px",
                                        color: "#0d6efd",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        fontWeight: "500",
                                      }}
                                      onClick={() => {
                                        GetDemandProgressHistory(
                                          proposal.DemandGenerationID,
                                        );
                                        setShowSpecific(1);
                                      }}
                                    >
                                      {proposal.DemandGenerationID}
                                    </td>
                                    <td className="py-2">
                                      {proposal.BillAmount?.toLocaleString("en-IN")}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {
                                      formatDateTime(proposal.Date)}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.CurrentDesignation}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.BillStatus === "Completed"
                                        ? "Release by BDS"
                                        : proposal.BillStatus}
                                    </td>
                                  </tr>
                                );
                              })
                            )}
                          </>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-12 mt-4 mb-2">
                      <div className="row">
                        <div className="col-6">
                          <p
                            className="text-gray-600"
                            style={{ fontSize: "18px" }}
                          >
                            {proposallist.length > 0
                              ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, filteredBills.length)} of ${filteredBills.length} entries`
                              : "Showing 0 to 0 of 0 entries"}
                          </p>
                        </div>
                        <div
                          className="col-6"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                          }}
                        >
                          <GooglePagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {selectedProposal && (
              <div
                onClick={() => setSelectedProposal(null)}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.84)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999,
                }}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    borderRadius: "20px",
                    width: "50%",
                    maxHeight: "90vh",
                    overflow: "hidden",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                    position: "relative",
                  }}
                >
                  <div className="col-12">
                    <div className="col-12  mb-3">
                      <div className="row">
                        <div className="col-6">
                          <h5 className="fw-bold">{t("Bill Details")}</h5>
                        </div>

                        <div
                          className="col-6"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <button
                            onClick={() => setSelectedProposal(null)}
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              backgroundColor: "red",
                              border: "none",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              fontSize: "24px",
                              fontWeight: "bold",
                              color: "white",
                              lineHeight: 1,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-12"
                      style={{
                        height: "59vh",
                        overflowX: "hidden",
                        overflowY: "scroll",
                        scrollBehavior: "smooth",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          height: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <tbody>
                          {Object.entries(selectedProposal).map(
                            ([key, value], index) => (
                              <>
                                <tr
                                  key={key}
                                  style={{
                                    backgroundColor:
                                      index % 2 === 0 ? "#2B75D5" : "#cce0f9",
                                    border: "1px solid #cce0f9",
                                  }}
                                >
                                  <td
                                    style={{
                                      fontWeight: "bold",
                                      padding: "8px",
                                      width: "40%",
                                      backgroundColor: "#2B75D5",
                                      color: "white",
                                      border: "1px solid #cce0f9",
                                    }}
                                  >
                                    {key}
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      color: "black",
                                      backgroundColor:
                                        index % 2 === 0 ? "#E3EBF5" : "#D0DEF1",
                                    }}
                                  >
                                    {/* Handle Upload Bill Copy link */}
                                    {key === "Upload Demand Copy" && value ? (
                                      <a
                                        href={`${apiurl}/BillCopyDocsImages/${value}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {value}
                                      </a>
                                    ) : value === null || value === "" ? (
                                      "-"
                                    ) : (
                                      value.toString()
                                    )}
                                  </td>
                                </tr>
                              </>
                            ),
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {showspecific == 1 && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                // justifyContent:"space-around",
                gap: "10px",
                marginBottom: "15px",
                paddingLeft: "20px",
                marginTop: "10px",
              }}
            >
              <button
                className="btn btn-danger "
                onClick={() => {
                  setShowSpecific(0);
                }}
              >
                Back
              </button>

              <div style={{ fontSize: "16px" }}>
                <span style={{ fontWeight: "bold" }}>
                  Demand Generation ID :
                </span>{" "}
                {approval.message?.[0]?.DemandGenerationID}
                {/* {approval[0]?.DemandGenerationID} */}
              </div>
            </div>
            <div className="col-12 pb-5">
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  boxShadow: "0px 0px 5px 1px #E4E8EC",
                  borderRadius: "20px",
                  width: "90%",
                  maxWidth: "100%",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  style={{ background: "#2C78DB", overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}
                >
                  <table
                    className="m-0 p-0 BillsOutwardTable"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead  style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                        }}
                      >
                        <th style={{ minWidth: "80px", padding: "8px" }}>
                          {t("Sr.No.")}
                        </th>

                        <th style={{ minWidth: "80px", padding: "8px" }}>
                          {t("Name")}
                        </th>
 
                        <th style={{ minWidth: "250px", padding: "8px" }}>
                          {t("Designation")}
                        </th>
 
                        <th style={{ minWidth: "250px", padding: "8px" }}>
                          {t("From Date")}
                        </th>
                          <th style={{ minWidth: "250px", padding: "8px" }}>
                          {t("To Date")}
                        </th>
                      </tr>
                    </thead>
 
                    <tbody>
  {(() => {
    const data = approval?.message?.[0];
    const isOld = Number(data?.IsOldDemand) === 1;
 
    const users = Array.isArray(approval?.districtUsers)
      ? approval.districtUsers
      : [];
 
    console.log("Approval Data:", data);
    console.log("All Users:", users);
 
    let approvalData = [
      {
        role: "Department Auditor",
        fromDate: data?.GM_BillReceivedDate,
        toDate: data?.GM_Approval_Date,
        userType: "District",
      },
      {
        role: "Department HOD(EE)",
        fromDate: data?.GM_Approval_Date,
        toDate: data?.Acnt_Approval_Date,
        userType: "District",
      },
      {
        role: "Finance Department(Auditor)",
        fromDate: data?.Acnt_Approval_Date,
        toDate: data?.Admin_Approval_Date,
        userType: "District",
      },
      {
        role: "FD AAO",
        fromDate: data?.Admin_Approval_Date,
        toDate: data?.Approvance4Date,
        userType: "District",
      },
   
      {
        role: "Deputy CAFO",
        fromDate: data?.Approvance5Date,
        toDate: data?.Approvance6Date,
        userType: "District",
      },
      {
        role: "CAFO",
        fromDate: data?.Approvance6Date,
        toDate: data?.Approvance7Date,
        userType: "District",
      },
      {
        role: "RDD Checker(ASO)",
        fromDate: isOld ? data?.GM_BillReceivedDate : data?.Approvance7Date,
        toDate: data?.Approvance8Date,
        userType: "State",
      },
      {
        role: "RDD Section Officer",
        fromDate: data?.Approvance8Date,
        toDate: data?.Approvance9Date,
        userType: "State",
      },
    ].map((item) => {
 
      const requiredRole = item.role
        ?.trim()
        .toLowerCase();
 
      const matchedUser = users.find((user) => {
 
        const dbRole = user?.Role
          ?.trim()
          .toLowerCase();
 
        const department = user?.Department_Name
          ?.trim()
          .toLowerCase();
 
        const district = user?.District
          ?.trim()
          .toLowerCase();
 
        // Role must match
        if (dbRole !== requiredRole) {
          return false;
        }
 
        // State-level users
        if (item.userType === "State") {
          return (
            department === "state" ||
            district === "state"
          );
        }
 
        // District-level users
      const demandDistrict = data?.District
  ?.trim()
  .toLowerCase();
 
const parentDistrict = demandDistrict?.includes("-")
  ? demandDistrict.split("-")[0].trim()
  : demandDistrict;
 
return (
  department === "district" &&
  (
    district === demandDistrict ||
    district === parentDistrict
  )
);
      });
 
      console.log(
        "Approval Role:",
        item.role,
        "User Type:",
        item.userType,
        "Matched User:",
        matchedUser
      );
 
      return {
        ...item,
        Name: matchedUser?.FullName || "-",
        role: matchedUser?.Role || item.role,
      };
    });

    // 🔥 old-format bills only ever go through these two stages
if (isOld) {
  approvalData = approvalData.filter((item) =>
    ["RDD Checker(ASO)", "RDD Section Officer"].includes(item.role),
  );
}
 
    // const formatDateTime = (date) => {
    //   if (!date) return "-";
 
    //   const parsedDate = new Date(date);
 
    //   if (isNaN(parsedDate.getTime())) {
    //     return "-";
    //   }
 
    //   return parsedDate.toLocaleString("en-IN", {
    //     day: "2-digit",
    //     month: "2-digit",
    //     year: "numeric",
    //     hour: "2-digit",
    //     minute: "2-digit",
    //     second: "2-digit",
    //     hour12: true,
    //   });
    // };
 
    return approvalData.map((item, index) => {
      const bgColor =
        index % 2 === 0
          ? "#E5F4FB"
          : "#CFE4F1";
 
      return (
        <tr
          key={index}
          style={{
            backgroundColor: bgColor,
            fontSize: "18px",
          }}
        >
          <td style={{ padding: "8px" }}>
            {index + 1}
          </td>
 
          <td style={{ padding: "8px" }}>
            {item.Name}
          </td>
 
          <td style={{ padding: "8px" }}>
            {item.role}
          </td>
 
          <td style={{ padding: "8px" }}>
            {formatDateTime(item.fromDate)}
          </td>
 
          <td style={{ padding: "8px" }}>
            {formatDateTime(item.toDate)}
          </td>
        </tr>
      );
    });
  })()}
</tbody>
                  </table>

                  {/* old code */}
                  {/* <table
                    className="m-0 p-0 BillsOutwardTable"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "12px",
                        }}
                      >
                        <th style={{ minWidth: "80px", padding: "8px" }}>
                          {t("Sr.No.")}
                        </th>

                        <th style={{ minWidth: "80px", padding: "8px" }}>
                          {t("Name")}
                        </th>
 
                        <th style={{ minWidth: "250px", padding: "8px" }}>
                          {t("Designation")}
                        </th>
 
                        <th style={{ minWidth: "250px", padding: "8px" }}>
                          {t("From Date")}
                        </th>
                          <th style={{ minWidth: "250px", padding: "8px" }}>
                          {t("To Date")}
                        </th>
                      </tr>
                    </thead>
 
                    <tbody>
                      {(() => {
                       const data = approval?.[0];
 
                    const approvalData = [ { role: "Department Auditor", fromDate: data?.GM_BillReceivedDate, toDate: data?.GM_Approval_Date, }, { role: "Department HOD(EE)", fromDate: data?.GM_Approval_Date, toDate: data?.Acnt_Approval_Date, }, { role: "FD Auditor", fromDate: data?.Acnt_Approval_Date, toDate: data?.Admin_Approval_Date, }, { role: "FD AAO", fromDate: data?.Admin_Approval_Date, toDate: data?.Approvance4Date, }, { role: "FD AO", fromDate: data?.Approvance4Date, toDate: data?.Approvance5Date, }, { role: "Deputy CAFO", fromDate: data?.Approvance5Date, toDate: data?.Approvance6Date, }, { role: "CAFO", fromDate: data?.Approvance6Date, toDate: data?.Approvance7Date, }, { role: "RDD Checker", fromDate: data?.Approvance7Date, toDate: data?.Approvance8Date, }, { role: "RDD Section Officer", fromDate: data?.Approvance8Date, toDate: data?.Approvance9Date, }, ];
 
                    const formatDateTime = (date) => { if (!date) return "-";
                       const parsedDate = new Date(date); if (isNaN(parsedDate.getTime()))
                        return "-";
                       return parsedDate.toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true, }); };
                        return approvalData.map((item, index) => {
                          const bgColor =
                            index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
 
                          return (
                            <tr
                              key={index}
                              style={{
                                backgroundColor: bgColor,
                              }}
                            >
                              <td style={{ padding: "8px" }}>{index + 1}</td>
 
                              <td style={{ padding: "8px" }}>{item.role}</td>
 
                          <td style={{ padding: "8px" }}> {formatDateTime(item.fromDate)} </td> <td style={{ padding: "8px" }}> {formatDateTime(item.toDate)} </td>
                            </tr>
                          );
                        });
                      })()}
                    </tbody>
                  </table> */}
                </div>
              </div>
            </div>
          </>
        )}
        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.4)",
              backdropFilter: "blur(2px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="Adminloader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewDemandGeneration;
